module.exports = __webpack_public_path__ + "static/media/2-_DSC0706.1792b11b.jpg";